import styled, { themeGet } from '@/styles/styled'
import { CardHeader, Table } from '@/components'

export const StyledHeader = styled(({ ...props }) => <CardHeader {...props} />)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 19px 20px;
`

export const StyeldMap = styled.div`
  padding: 25px 20px;
`

export const StyledTable = styled(({ ...rest }) => <Table {...rest} />)`
  font-size: 13px;
  thead th,
  tbody td {
    border-color: ${themeGet('colors.light')};
  }
  tbody td {
    padding-top: 8px;
    padding-bottom: 8px;
  }
`

export const StyledTH = styled.th`
  font-family: ${themeGet('fonts.interUi')};
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: ${themeGet('colors.text3')};
  &:first-child {
    padding-left: 10px;
    width: 40px;
  }
  &:not(:first-child) {
    width: 25px;
    text-align: right;
  }
  &:last-child {
    padding-right: 10px;
  }
`

export const StyledTD = styled.td`
  padding: 0 10px; /* 모든 셀에 동일한 padding 적용 */
  height: 40px; /* 고정된 셀 높이 */
  line-height: 40px; /* 텍스트 중앙 정렬 */
  vertical-align: middle;

  &:first-child {
    font-weight: 500;
  }

  &:not(:first-child) {
    text-align: right;
  }

  &:last-child {
    padding-right: 10px;
  }

  cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};

  white-space: normal; /* 텍스트가 여러 줄로 표시되도록 수정 */
  overflow: hidden;
  text-overflow: ellipsis;

  /* 맨 위, 맨 아래 선 제거 */
  border-top: none;
  border-bottom: none;

  /* tbody에서 첫 번째 tr의 td는 border-top 제거 */
  tbody tr:first-child & {
    border-top: none;
  }

  /* tbody에서 마지막 tr의 td는 border-bottom 제거 */
  tbody tr:last-child & {
    border-bottom: none;
  }

  /* 셀 텍스트가 길어져서 높이가 다르게 보이지 않도록 max-width 제한 */
  max-width: 200px; /* 필요에 따라 수정 */
`
